import { Button } from '@rrexpress/core';

const ActionPrint = ({ onClick }: { onClick: () => void }) => (
  <Button backgroundColor="#E6EFF8" onClick={onClick} size="sm" type="button">
    <svg color="#005EB8" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2C6.89543 2 6 2.89543 6 4V7C3.79086 7 2 8.79086 2 11V17C2 18.1046 2.89543 19 4 19H6V20C6 21.1046 6.89543 22 8 22H16C17.1046 22 18 21.1046 18 20V19H20C21.1046 19 22 18.1046 22 17V11C22 8.79086 20.2091 7 18 7V4C18 2.89543 17.1046 2 16 2H8ZM6 16V17H4V11C4 9.89543 4.89543 9 6 9H8H16H18C19.1046 9 20 9.89543 20 11V17H18V16C18 14.8954 17.1046 14 16 14H8C6.89543 14 6 14.8954 6 16ZM16 7V4H8V7H16ZM16 16H8V20H16V16ZM6 12C6.55228 12 7 11.5523 7 11C7 10.4477 6.55228 10 6 10C5.44772 10 5 10.4477 5 11C5 11.5523 5.44772 12 6 12Z" fill="#666666" />
    </svg>
  </Button>
);

export default ActionPrint;
